<script setup>
import {computed, ref} from 'vue';
import {useProductStore} from "@js/store/ProductStore.js";
import ProductCharacteristicsFeature from "@js/components/Sections/Product/ProductCharacteristicsFeature.vue";
import {Link} from "@inertiajs/vue3";
import IconCalculator from "@js/components/Icons/IconCalculator.vue";
import IconInterior from "@js/components/Icons/IconInterior.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";
import design_img from '@img/callback/3d_design_request.webp';

const productStore = useProductStore();
const callbackStore = useCallbackStore();

// флаг, надо ли рисовать рамку
const hasBorder = ref(false);
// ref на сам img в DOM
const imgRef = ref(null);

const popup_data = {
    title: 'Запись на 3D дизайн-проект',
    bitrix_title: 'Запись на 3D дизайн-проект',
    img_src: design_img,
}

// при загрузке картинки проверяем фон
function onImageLoad() {
    const img = imgRef.value;
    if (!img) return;
    // создаём невидимый canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', {willReadFrequently: true});
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    ctx.drawImage(img, 0, 0);

    // пробуем углы: (0,0), (w-1,0), (0,h-1), (w-1,h-1)
    const corners = [
        ctx.getImageData(0, 0, 1, 1).data,
        ctx.getImageData(canvas.width - 1, 0, 1, 1).data,
        ctx.getImageData(0, canvas.height - 1, 1, 1).data,
        ctx.getImageData(canvas.width - 1, canvas.height - 1, 1, 1).data,
    ];

    // проверим, есть ли прозрачные пиксели или все пиксели очень светлые
    const anyTransparent = corners.some(([r, g, b, a]) => a < 255);
    const avgBrightness = corners.reduce((sum, [r, g, b]) => sum + (r + g + b) / 3, 0) / corners.length;

    // если есть прозрачность ИЛИ фон очень светлый (яркость > 245 из 255) — ставим рамку
    hasBorder.value = anyTransparent || avgBrightness > 245;
}
</script>

<template>
    <div class="relative">
        <Link v-if="productStore.product.brand.image"
              :href="route('catalog', {
                          category_title: productStore.product.category.slug,
                          brands: JSON.stringify([productStore.product.brand.id])
                          })"
              class="group inline-block"
              :alt="productStore.product.brand.title">
            <img ref="imgRef"
                 :src="`/assets/brands/${productStore.product.brand.image}`"
                 class="h-[65px] w-auto rounded-lg object-cover mb-5 shadow transition"
                 @load="onImageLoad"
                 :class="[hasBorder ? 'border border-gray-200 p-1 md:group-hover:border-baseColor' : '']"
                 :alt="productStore.product.brand.title"
                 :title="productStore.product.brand.title"/>
        </Link>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
            <button @click.prevent="callbackStore.showBaseCallbackPopup(popup_data)"
                    class="flex items-center justify-center text-start gap-3 text-sm w-full bg-transparent border border-dashed border-gray-500 text-black p-3 rounded-lg md:hover:bg-baseColor font-semibold transition">
                <IconInterior class="min-w-7 max-w-7 min-h-7 max-h-7"/>
                Запись на 3D дизайн-проект
            </button>
            <Link :href="route('calculator',{
                                                tile_length: productStore.product.length,
                                                tile_width: productStore.product.width,
                                                tile_price: productStore.product.price,
                                            })"
                  class="flex items-center justify-center text-start gap-3 text-sm w-full bg-transparent border border-dashed border-gray-500 text-black p-3 rounded-lg md:hover:bg-baseColor font-semibold transition">
                <IconCalculator class="min-w-7 max-w-7 min-h-7 max-h-7"/>
                Калькулятор плитки по площади
            </Link>
        </div>
        <div class="flex items-center gap-5 w-full bg-grayBg shadow p-3 rounded-lg">
            <img src="@img/defaults/small_license.webp"
                 alt="Лицензия" title="Лицензия"/>
            <div class="text-sm font-medium">
                Этот товар официально сертифицирован в компании производителя и имеет гарантийный срок .
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
